import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingWizard } from '@/components/onboarding/OnboardingWizard';
import { getOnboardingState } from '@/lib/onboarding-state';

export function SetupPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const state = getOnboardingState();

    // If already completed, redirect to dashboard
    if (state?.currentStep === 'completed') {
      navigate('/app', { replace: true });
    }
  }, [navigate]);

  return <OnboardingWizard />;
}
